import React from "react";
import { Button as MuiButton, CircularProgress, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  NextButton: {
    borderRadius: "100px",
    marginLeft: "3%",
    backgroundColor: "#45A7DF",
    color: "#FFFFFF",
    fontSize: "0.8em",
    padding: "2% 5% 2% 5%",
    "&:hover": {
      backgroundColor: "#45A799",
    },
  },

  BackButton: {
    borderRadius: "100px",
    marginLeft: "3%",
    border: "1px solid #C6C8CC",
    backgroundColor: "#FFFFFF",
    color: "#45A7DF",
    fontSize: "0.8em",
    padding: "2% 5% 2% 5%",
    "&:hover": {
      backgroundColor: "#cdcdcd",
      color: "#fff",
    },
  },

  SucessButton: {
    borderRadius: "100px",
    //marginLeft: "3%",
    backgroundColor: "#2e7d32",
    color: "#FFFFFF",
    fontSize: "0.8em",
    "&:hover": {
      textDecoration: "none",
      backgroundColor: "#1b5e20",
      boxShadow:
        "rgb(0 0 0 / 20%) 0px 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px",
    },
  },

  BlankButton: {
    borderRadius: "100px",
    marginLeft: "3%",
    border: "1px solid #C6C8CC",
    backgroundColor: "#FFFFFF",
    color: "#45A7DF",
    fontSize: "0.8em",
    "&:hover": {
      backgroundColor: "#FFFFFF",
    },
  },

  ErrorButton: {
    borderRadius: "100px",
    marginLeft: "3%",
    border: "1px solid #d32f2f",
    backgroundColor: "#FFFFFF",
    color: "#d32f2f",
    fontSize: "0.8em",
    "&:hover": {
      textDecoration: "none",
      backgroundColor: "#FFFFFF",
      boxShadow:
        "rgb(0 0 0 / 20%) 0px 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px",
    },
  },

  ErrorButtonNoBorder: {
    borderRadius: "100px",
    marginLeft: "3%",
    backgroundColor: "#FFFFFF",
    color: "#d32f2f",
    fontSize: "0.8em",
    "&:hover": {
      textDecoration: "none",
      backgroundColor: "#FFFFFF",
      boxShadow:
        "rgb(0 0 0 / 20%) 0px 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px",
    },
  },

  BlankButtonNoBorder: {
    borderRadius: "100px",
    marginLeft: "3%",
    backgroundColor: "#FFFFFF",
    color: "#45A7DF",
    fontSize: "0.8em",
    "&:hover": {
      textDecoration: "none",
      backgroundColor: "#FFFFFF",
      boxShadow:
        "rgb(0 0 0 / 20%) 0px 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px",
    },
  },
}));

interface IButtonProps {
  text: any;
  isLoading?: boolean;
  widthFull?: boolean;
  size?: "sm" | "lg";
  type?:
  | "Next"
  | "Back"
  | "Success"
  | "Blank"
  | "Error"
  | "ErrorNoBorder"
  | "BlankNoBorder";
  onClick?: () => void;
}

export default function Button(props: IButtonProps) {
  const classes = useStyles();

  return (
    <React.Fragment>
        <MuiButton
          disabled={props.isLoading}
          className={
            {
              Next: classes.NextButton,
              Back: classes.BackButton,
              Success: classes.SucessButton,
              Blank: classes.BlankButton,
              Error: classes.ErrorButton,
              ErrorNoBorder: classes.ErrorButtonNoBorder,
              BlankNoBorder: classes.BlankButtonNoBorder,
            }[props.type ?? "Next"]
          }
          onClick={props.onClick}
        >
          {props.text}

          {props.isLoading && props.type === "Next" ? (
            <CircularProgress style={{ color: "white", marginLeft: 5 }} size={20} />
          ) : null}
        </MuiButton>
    </React.Fragment>
  );
}
